//
// fancybox.js
// Theme module
//

(function() {
  //
  // Functions
  //

  function globalOptions() {
    $.fancybox.defaults.image.preload = true;
    $.fancybox.defaults.toolbar = false;
    $.fancybox.defaults.clickContent = false;
  }

  //
  // Events
  //

  if (window.jQuery && window.jQuery().fancybox) {
    globalOptions();
  }
})();
